'use client';

import { ApolloNextAppProvider } from '@apollo/experimental-nextjs-app-support';

import { makeClient } from './apollo/client';
type NextAppGraphQLProvider = {
  children: React.ReactNode;
};
const NextAppGraphQLProvider = ({ children }: NextAppGraphQLProvider) => (
  <ApolloNextAppProvider makeClient={makeClient}>
    {children}
  </ApolloNextAppProvider>
);

export { NextAppGraphQLProvider };
